import {
  useCallback,
  useEffect,
  useMemo,
  useState
} from "react";

import {
  // GridActionsCellItem,
  GridValueGetterParams,
  GridColDef,
} from "@mui/x-data-grid";

import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button/Button';
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box/Box";
import AddIcon from '@mui/icons-material/Add';
import LockIcon from '@mui/icons-material/Lock';
import CheckIcon from '@mui/icons-material/Check';
import CrossIcon from '@mui/icons-material/Close';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';

import CustomDataGrid from '../../components/DataGrid/DataGrid';
import { /* deleteAccount, */ fetchAccounts, selectedAccountID } from "../../store/accountThunk";
import { switchAccount } from '../../store/authSlice';
import { IAccount } from "../../utils/account.types";
import { PermissionsEnum } from "../../utils/auth.types";

import {
  useAppDispatch,
  useAppSelector,
} from "../../store/hooks";
import { ApiStatus } from "../../utils/api.types";
import CustomDialog from "../../components/Dialog/Dialog";
import { addAccount } from "../../store/accountThunk";
import { fetchCountries } from '../../store/countryStore/countryThunk';
import { Avatar, Card, CardContent, Grid, Tooltip } from "@mui/material";
import axios from '../../utils/axios';

/**
 * Component for Managing Accounts. 
 */
const Account = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { accounts, status } = useAppSelector(state => state.account);
  const { user, permissions, selectedAccount } = useAppSelector(state => state.auth);
  const [open, setOpen] = useState(false);

  const [countriesByCountryId, setCountriesByCountryId] = useState<any>({});
  
  const canCreateAccount = permissions?.includes(PermissionsEnum.Account_Create);
  // const canUpdateAccount = permissions?.includes(PermissionsEnum.Account_Update);
  const canViewAccount = permissions?.includes(PermissionsEnum.Account_View);
  // const canDeleteAccount = permissions?.includes(PermissionsEnum.Account_Delete);
  
  /**
   * Fetch all the accounts on Accounts page load.
   */
  useEffect(() => {
    dispatch(fetchAccounts());
  }, [dispatch]);

  const tempCountries:any = {};

  useEffect(() => {
    const getCountry = async () => {    
      const countrDdata: any = await dispatch(fetchCountries());  
      
      countrDdata.payload.map((c: any) => { 
        tempCountries[c._id] = c; 
      });
      
      setCountriesByCountryId(tempCountries);
    }
    getCountry();
    //console.log(tempCountries);
  }, []);

  /**
   * Method to open Account Form dialog.
   */
  const [companyBlock, setCompanyBlock] = useState<string>();
  useEffect(() => { axios.get('/api/v1/subscription/current').then((res) => setCompanyBlock(res.data?.addCompanyBlock)).catch(() => {}); }, []);

  const handleAddAccount = () => {
    //navigate(`account-info`);
    handleOpen();
  };

  /**
   * Handler for account name click.
   */
  const handleAccountNameClick = useCallback(({ _id }: IAccount) => {
    dispatch(selectedAccountID(_id));
    navigate(`account-details/${_id}`);
  }, [navigate, dispatch]);

  /**
   * Method to handle delete account.
   */
  // const deleteSelectedAccount = useCallback((account: IAccount) => () => {
  //   // Dispatch action to delete account.
  //   dispatch(deleteAccount(account._id));
  // }, [dispatch]);

  /**
   * Method to handle edit account.
   */
  // const editSelectedAccount = useCallback(({ _id }: IAccount) => () => {
  //   navigate(`/account/edit/${_id}`);
  // }, [navigate]);

 
  /**
   * Method to set address column value.
   */
  const getAddress = (param: GridValueGetterParams) => {
    
    if (param.value) {
      //const { address, city, country, zip } = param.value;
      let address:String;
      let city:String;
      let state:String;
      let country:any;
      let zip:String;

      address = (param?.value[0]?.line1 ) ? param.value[0].line1 + ', ': "";
      address = (param?.value[0]?.line2 ) ? address +''+ param.value[0].line2 + `, ` : address;
      address = (param?.value[0]?.line3 ) ? address +''+param.value[0].line3 + `, ` : address;

      city = param.value[0]?.city ? param.value[0].city + ", " : "";

      state = param.value[0]?.state ? param.value[0].state + ", " : "";

      zip = param.value[0]?.code ? param.value[0].code + `, ` : "";
      
      country = tempCountries[param.value[0]?.country]?.name || '-';
      
      address = address +' '+  city +' '+ state +' '+ country +' '+ zip;

      return address;
    }
  }

  /**
   * Column defs for account list data grid.
   */
  const columns: GridColDef[] = useMemo(() => [
    {
      field: "name",
      headerName: 'Name',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <Typography
          sx={{ cursor: 'pointer', fontWeight: 'bold' }}
          component={Link}
          underline='hover'
          onClick={() => handleAccountNameClick(row)}
        >
          <Grid container sx={{ display: 'flex', flexDirection: 'row', minWidth:'300px', justifyContent: 'left', alignItems: 'left' }} spacing={1}>
            <Grid item>
              <Avatar
                alt={value}
                imgProps={{ "referrerPolicy": 'no-referrer' }}
                src={`${row.logo}`}
                variant='square'
              />
            </Grid>
            <Grid item sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '150px' }}>
              {value}
            </Grid>
          </Grid>
        </Typography>
      )
    },
    {
      field: "legalName",
      headerName: 'Legal Name',
      type: "string",
      flex: 1,
    },
    {
      field: "owner",
      headerName: 'Owner',
      type: "string",
      flex: 1,
      valueGetter: ({ value }: GridValueGetterParams) => value?.name || ''
    },
    {
      field: "subscription",
      headerName: 'Subscription',
      type: "string",
      flex: 1,
      valueGetter: ({ value }: GridValueGetterParams) => value?.plan?.toUpperCase() || ''
    },
    {
      field: "isActive",
      headerName: 'Is Active',
      type: "string",
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <div className="flex-column padIcon">{value ? <CheckIcon/>: <CrossIcon/>}</div>
      ),
      flex: 1
    },
    {
      field: 'addresses',
      headerName: 'Address',
      type: "singleSelect",
      flex: 1,
      valueGetter: getAddress,
    },
    // {
    //   field: "actions",
    //   headerName: 'Actions',
    //   type: "actions",
    //   flex: 1,
    //   getActions: (params: GridValueGetterParams) => {
    //     const editAction = (
    //       <GridActionsCellItem
    //         icon={<EditIcon />}
    //         title="Edit"
    //         label="Edit"
    //         onClick={() => handleAccountNameClick(params.row)}
    //       />
    //     );

    //     const deleteAction = (
    //       <GridActionsCellItem
    //         icon={<DeleteIcon />}
    //         title="Delete"
    //         label="Delete"
    //         onClick={deleteSelectedAccount(params.row)}
    //       />
    //     );

    //     const actions: JSX.Element[] = [];

    //     // Push edit action if user has update permission.
    //     if (canUpdateAccount) {
    //       actions.push(editAction);
    //     }

    //     // Push edit action if user has delete permission.
    //     if (canDeleteAccount) {
    //       actions.push(deleteAction);
    //     }

    //     return actions;
    //   }
    // }
  ], [
    // deleteSelectedAccount,
    // editSelectedAccount,
    // canUpdateAccount,
    // canDeleteAccount,
    handleAccountNameClick
  ]);

  const onSubmit = async (data: any) => {
    // Dispatch add account action.
    try {
      await dispatch(addAccount(data)).unwrap().then((data) => {
        if(data.account) {
          let selectId = selectedAccount._id

          if(selectId) {
            dispatch(switchAccount({ accountId: selectId, userId: user._id }));
          }
          navigate(`account-details/${data.account._id}`);
        }
      });

    } catch (error: any) {
      // Empty catch block.
    }
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    
      
    <>
    {Object.keys(countriesByCountryId).length && 
     
      <Card sx={{ border: 'none', boxShadow: 'none', backgroundColor: 'transparent' }}>
        <CardContent sx={{ paddingTop: '16px', paddingRight: '16px' }}>

          <Box sx={{ display: "flex", justifyContent: "end", paddingTop: '8px', px: '24px' }}>
            {canCreateAccount && <Tooltip arrow title={companyBlock || ''}><span><Button
              startIcon={companyBlock ? <LockIcon /> : <AddIcon />}
              variant="contained"
              color='secondary'
              onClick={handleAddAccount}
              disabled={!!companyBlock}
            >
              Add New Business
            </Button></span></Tooltip>}
          </Box>
          <Box sx={{ minHeight: '70vh', height: '70vh', width: "100%", marginTop: '24px' }}>
            {canViewAccount && <CustomDataGrid
              columns={columns}
              rows={accounts}
              getRowId={(row) => row._id}
              loading={status === ApiStatus.LOADING}
            />}
          </Box>
          {open && <CustomDialog title='Create Business' open={open} onClose={handleClose} onSubmit={onSubmit} isAddButton={true} />}
        </CardContent>
      </Card>
       }
    </>
 
  )
}

export default Account;
